import { EventPayload } from './EventEmitter';
import { getSingleton } from './RemoteModuleManager';

// Usages
export const loadRemoteModule = (container: string, module: string): Promise<unknown> => {
  return getSingleton().loadRemoteModule(container, module);
};

export const prefetchRemoteModule = (container: string, module: string): Promise<unknown> => {
  return getSingleton().prefetchRemoteModule(container, module);
};

export const loadRemoteEntryContainer = (container: string): Promise<unknown> => {
  return getSingleton()
    .loadRemoteEntryWithoutInit(container)
    .then(handler => handler.getContainer());
};

export const emit = (name: string, payload?: EventPayload) => getSingleton().emit(name, payload);

declare global {
  interface Window {
    __MEEGO_GLOBAL__: {
      loadRemoteModule: typeof loadRemoteModule;
      loadRemoteEntry: typeof loadRemoteEntryContainer;
      prefetchRemoteModule: typeof prefetchRemoteModule;
    };
  }
}

export const initGlobal = () => {
  window.__MEEGO_GLOBAL__ = window.__MEEGO_GLOBAL__ || {
    loadRemoteModule,
    loadRemoteEntryContainer,
  };

  return window.__MEEGO_GLOBAL__;
};
